import { CourseProgress as ICourseProgress } from "@/api/models/course-progress";

export const learningProgressPercent = (progress: ICourseProgress) => {
  let allData: number | undefined;
  let correctData: number | undefined;
  let lecturesCount = progress?.lectures?.length ? progress.lectures.length : 0;

  let testsLecture: number = 0;
  progress?.lectures?.forEach(el => {
    if (el.test) {
      testsLecture += 1;
    }
  });

  let testCount = progress?.test ? 1 : 0;
  let practiceCount = progress?.practice ? 1 : 0;

  allData = lecturesCount + testCount + practiceCount + testsLecture;

  let correctReadAtLectures: number = progress?.lectures?.filter(
    el => el.readAt
  ).length
    ? progress?.lectures?.filter(el => el.readAt).length
    : 0;

  let correctTestLectures: number = 0;
  progress?.lectures?.forEach(el => {
    if (el.test && el.test.success) {
      correctTestLectures += 1;
    }
  });

  let correctTestCount = progress?.test?.success ? 1 : 0;
  let correctPracticeCount = progress?.practice?.passedAt ? 1 : 0;

  correctData =
    correctTestLectures +
    correctTestCount +
    correctPracticeCount +
    correctReadAtLectures;

  return Math.round((100 * correctData) / allData);
};
